import { ReactNode } from "react";
import { PrimaryButton } from "../../Button";
import styled from "styled-components";
import { Action, ActionComponent } from "../../../internalComponents";
import { Modal } from "../Modal";

const StyledActions = styled.div`
  border-top: 1px solid var(--color-primary-200);
`;

const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ActionButtonWrapper = styled.div`
  button {
    white-space: nowrap;
  }
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 10px;
`;

type ActionsProps = {
  primaryButton?: {
    text: string;
    handler: () => void;
    id?: string;
    disabled?: boolean;
    loading?: boolean;
  };

  secondaryButtonText?: string;

  /** Render a link or unstyled button along with the main actions */
  extraAction?: Action;

  children?: ReactNode;
};

export const Actions = ({
  extraAction,
  primaryButton,
  secondaryButtonText,
  children,
}: ActionsProps) => {
  return (
    <StyledActions>
      {children ? (
        children
      ) : (
        <ActionsWrapper>
          {extraAction && (
            <ActionButtonWrapper>
              <ActionComponent action={extraAction} />
            </ActionButtonWrapper>
          )}
          <ButtonArea>
            {secondaryButtonText && (
              <Modal.CloseButton>
                {secondaryButtonText || "Cancel"}
              </Modal.CloseButton>
            )}
            <PrimaryButton
              id={primaryButton?.id}
              disabled={primaryButton?.disabled}
              loading={primaryButton?.loading}
              onClick={primaryButton?.handler}
            >
              {primaryButton?.text}
            </PrimaryButton>
          </ButtonArea>
        </ActionsWrapper>
      )}
    </StyledActions>
  );
};
